import { Component, HostBinding } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SetMdDialog } from './shared/dialogs/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'app';
  @HostBinding('class') public cssClass = '';
  constructor(
    private mdDialog: MatDialog,
    public translate: TranslateService,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    translate.addLangs(['en', 'bn']);
    localStorage.setItem('lang', JSON.stringify({ lang: 'English', value: 'en' }));
    translate.setDefaultLang('en');
    SetMdDialog(this.mdDialog);
  }
  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const childRoute = this.getChild(this.activatedRoute);
      // console.log(this.router.url.split('/').slice(-1)[0]);
      childRoute.data.subscribe((data) => {
        this.titleService.setTitle(data.title || this.router.url.split('/').slice(-1)[0] + ' - CAL Portal' || 'CAL Portal');
      });
    });
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
  getRouteState(route) {
    try {
      if (route && route.activatedRoute && route.activatedRoute.component && route.activatedRoute.component.name === 'AccountComponent') {
        return 'login';
      }
    } catch (e) {}
    return '*';
  }
}
